export default "__VITE_ASSET__DydeP0Bq__"